import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "create-form" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "form-wrap pt-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("h1", { class: "title" }, "Create Business Mail Template"),
    /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Create Business Mail.")
  ])
], -1)
const _hoisted_6 = { class: "offset-sm-4 col-sm-2 d-flex align-items-center justify-content-end" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left  mr-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "" }, "Title", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "" }, "Mail Template", -1)
const _hoisted_13 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_editor = _resolveComponent("editor")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("a", {
                href: "javascript:void(0)",
                type: "button",
                class: "btn default-btn d-inline-block",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backToBusinessMail && _ctx.backToBusinessMail(...args)))
              }, [
                _hoisted_7,
                _hoisted_8
              ])
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.validationList,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _hoisted_10,
            _withDirectives(_createVNode("input", {
              id: "titleOfForm",
              type: "text",
              class: "form-control",
              placeholder: "Purpose of Creating the Mail",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.title = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.title]
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_editor, {
              modelValue: _ctx.state.template,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.template = $event)),
              "api-key": "0mtfvz9o2d1dtxzrihma4kfs89lyd6hrg4wjexajn0j5f0ia",
              init: {
            selector: 'textarea.tinymce',
            theme: 'silver',
            height: 600,
            plugins: [
              'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
              'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
              'media', 'table', 'emoticons', 'help'
            ],
            toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags| image | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
            image_advtab: true,
            images_file_types: 'jpg,svg,webp',


          }
            }, null, 8, ["modelValue", "init"])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("a", {
              class: "btn default-btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createBusinessMailTemplate && _ctx.createBusinessMailTemplate(...args)))
            }, "Save")
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}